"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var elements_1 = require("../diagram/elements");
var history_1 = require("../diagram/history");
var model_1 = require("../diagram/model");
var dataFetcher_1 = require("./dataFetcher");
var layoutData_1 = require("./layoutData");
var AsyncModel = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncModel, _super);
    function AsyncModel(history, groupByProperties) {
        var _this = _super.call(this, history) || this;
        _this.groupByProperties = groupByProperties;
        _this.classTree = [];
        _this.linkSettings = {};
        _this.onLinkTypeVisibilityChanged = function (e) {
            if (e.source.visible) {
                if (!e.preventLoading) {
                    _this.requestLinksOfType([e.source.id]);
                }
            }
            else {
                for (var _i = 0, _a = _this.linksOfType(e.source.id); _i < _a.length; _i++) {
                    var link = _a[_i];
                    _this.graph.removeLink(link.id);
                }
            }
        };
        return _this;
    }
    Object.defineProperty(AsyncModel.prototype, "dataProvider", {
        get: function () { return this._dataProvider; },
        enumerable: true,
        configurable: true
    });
    AsyncModel.prototype.getClasses = function () {
        return this.classTree;
    };
    AsyncModel.prototype.subscribeGraph = function () {
        var _this = this;
        _super.prototype.subscribeGraph.call(this);
        this.graphListener.listen(this.graph.events, 'linkTypeEvent', function (e) {
            if (e.key === 'changeVisibility') {
                _this.onLinkTypeVisibilityChanged(e.data[e.key], e.key);
            }
        });
    };
    AsyncModel.prototype.setDataProvider = function (dataProvider) {
        this._dataProvider = dataProvider;
        this.fetcher = new dataFetcher_1.DataFetcher(this.graph, dataProvider);
    };
    AsyncModel.prototype.createNewDiagram = function (dataProvider) {
        var _this = this;
        this.resetGraph();
        this.setDataProvider(dataProvider);
        this.source.trigger('loadingStart', { source: this });
        return Promise.all([
            this.dataProvider.classTree(),
            this.dataProvider.linkTypes(),
        ]).then(function (_a) {
            var classTree = _a[0], linkTypes = _a[1];
            _this.setClassTree(classTree);
            var allLinkTypes = _this.initLinkTypes(linkTypes);
            return _this.loadAndRenderLayout({
                allLinkTypes: allLinkTypes,
                markLinksAsLayoutOnly: false,
            });
        }).catch(function (error) {
            console.error(error);
            _this.source.trigger('loadingError', { source: _this, error: error });
            return Promise.reject(error);
        });
    };
    AsyncModel.prototype.importLayout = function (params) {
        var _this = this;
        this.resetGraph();
        this.setDataProvider(params.dataProvider);
        this.source.trigger('loadingStart', { source: this });
        return Promise.all([
            this.dataProvider.classTree(),
            this.dataProvider.linkTypes(),
        ]).then(function (_a) {
            var classTree = _a[0], linkTypes = _a[1];
            _this.setClassTree(classTree);
            var allLinkTypes = _this.initLinkTypes(linkTypes);
            _this.setLinkSettings(params.linkSettings || []);
            var loadingModels = _this.loadAndRenderLayout({
                layoutData: params.layoutData,
                preloadedElements: params.preloadedElements || {},
                markLinksAsLayoutOnly: params.validateLinks || false,
                allLinkTypes: allLinkTypes,
                hideUnusedLinkTypes: params.hideUnusedLinkTypes,
            });
            var requestingLinks = params.validateLinks
                ? _this.requestLinksOfType() : Promise.resolve();
            return Promise.all([loadingModels, requestingLinks]);
        }).then(function () {
            _this.source.trigger('loadingSuccess', { source: _this });
        }).catch(function (error) {
            // tslint:disable-next-line:no-console
            console.error(error);
            _this.source.trigger('loadingError', { source: _this, error: error });
            return Promise.reject(error);
        });
    };
    AsyncModel.prototype.exportLayout = function () {
        var layoutData = layoutData_1.exportLayoutData(this.graph.getElements(), this.graph.getLinks());
        var linkSettings = this.graph.getLinkTypes()
            .map(function (_a) {
            var id = _a.id, visible = _a.visible, showLabel = _a.showLabel;
            return ({ id: id, visible: visible, showLabel: showLabel });
        });
        return { layoutData: layoutData, linkSettings: linkSettings };
    };
    AsyncModel.prototype.setClassTree = function (rootClasses) {
        var _this = this;
        var addClass = function (base, classModel) {
            var id = classModel.id, label = classModel.label, count = classModel.count, children = classModel.children;
            var richClass = new elements_1.FatClassModel({ id: id, label: label.values, count: count });
            richClass.setBase(base);
            _this.graph.addClass(richClass);
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                addClass(richClass, child);
            }
        };
        for (var _i = 0, rootClasses_1 = rootClasses; _i < rootClasses_1.length; _i++) {
            var root = rootClasses_1[_i];
            addClass(undefined, root);
        }
        this.classTree = this.graph.getClasses();
        this.source.trigger('changeClassTree', { source: this });
    };
    AsyncModel.prototype.initLinkTypes = function (linkTypes) {
        var types = [];
        for (var _i = 0, linkTypes_1 = linkTypes; _i < linkTypes_1.length; _i++) {
            var _a = linkTypes_1[_i], id = _a.id, label = _a.label;
            var linkType = new elements_1.FatLinkType({ id: id, label: label.values });
            this.graph.addLinkType(linkType);
            types.push(linkType);
        }
        return types;
    };
    AsyncModel.prototype.setLinkSettings = function (settings) {
        for (var _i = 0, settings_1 = settings; _i < settings_1.length; _i++) {
            var setting = settings_1[_i];
            var _a = setting.visible, visible = _a === void 0 ? true : _a, _b = setting.showLabel, showLabel = _b === void 0 ? true : _b;
            var linkTypeId = setting.id;
            this.linkSettings[linkTypeId] = { id: linkTypeId, visible: visible, showLabel: showLabel };
            var linkType = this.getLinkType(linkTypeId);
            if (linkType) {
                linkType.setVisibility({ visible: visible, showLabel: showLabel });
            }
        }
    };
    AsyncModel.prototype.loadAndRenderLayout = function (params) {
        var _a = params.layoutData, layoutData = _a === void 0 ? { cells: [] } : _a, _b = params.preloadedElements, preloadedElements = _b === void 0 ? {} : _b, markLinksAsLayoutOnly = params.markLinksAsLayoutOnly, hideUnusedLinkTypes = params.hideUnusedLinkTypes;
        var elementIrisToRequestData = [];
        var usedLinkTypes = {};
        var normalizedCells = layoutData.cells.map(layoutData_1.normalizeImportedCell);
        for (var _i = 0, normalizedCells_1 = normalizedCells; _i < normalizedCells_1.length; _i++) {
            var cell = normalizedCells_1[_i];
            if (cell.type === 'element') {
                var id = cell.id, iri = cell.iri, position = cell.position, size = cell.size, isExpanded = cell.isExpanded, group = cell.group;
                var template = preloadedElements[iri];
                var data = template || model_1.placeholderDataFromIri(iri);
                var element = new elements_1.Element({ id: id, data: data, position: position, size: size, expanded: isExpanded, group: group });
                this.graph.addElement(element);
                if (!template) {
                    elementIrisToRequestData.push(element.iri);
                }
            }
        }
        for (var _c = 0, normalizedCells_2 = normalizedCells; _c < normalizedCells_2.length; _c++) {
            var cell = normalizedCells_2[_c];
            if (cell.type === 'link') {
                var id = cell.id, typeId = cell.typeId, source = cell.source, target = cell.target, vertices = cell.vertices;
                var linkType = this.createLinkType(typeId);
                usedLinkTypes[linkType.id] = linkType;
                var link = this.addLink(new elements_1.Link({
                    id: id,
                    typeId: linkType.id,
                    sourceId: source.id,
                    targetId: target.id,
                    vertices: vertices,
                }));
                if (link) {
                    link.setLayoutOnly(markLinksAsLayoutOnly);
                }
            }
        }
        this.subscribeGraph();
        var requestingModels = this.requestElementData(elementIrisToRequestData);
        if (hideUnusedLinkTypes && params.allLinkTypes) {
            this.hideUnusedLinkTypes(params.allLinkTypes, usedLinkTypes);
        }
        return requestingModels;
    };
    AsyncModel.prototype.hideUnusedLinkTypes = function (allTypes, usedTypes) {
        for (var _i = 0, allTypes_1 = allTypes; _i < allTypes_1.length; _i++) {
            var linkType = allTypes_1[_i];
            if (!usedTypes[linkType.id]) {
                linkType.setVisibility({
                    visible: false,
                    showLabel: linkType.showLabel,
                });
            }
        }
    };
    AsyncModel.prototype.requestElementData = function (elementIris) {
        return this.fetcher.fetchElementData(elementIris);
    };
    AsyncModel.prototype.requestLinksOfType = function (linkTypeIds) {
        var _this = this;
        var linkTypes = linkTypeIds || this.graph.getLinkTypes()
            .filter(function (type) { return type.visible; })
            .map(function (type) { return type.id; });
        return this.dataProvider.linksInfo({
            elementIds: this.graph.getElements().map(function (element) { return element.iri; }),
            linkTypeIds: linkTypes,
        }).then(function (links) { return _this.onLinkInfoLoaded(links); });
    };
    AsyncModel.prototype.createClass = function (classId) {
        if (this.graph.getClass(classId)) {
            return _super.prototype.createClass.call(this, classId);
        }
        var classModel = _super.prototype.createClass.call(this, classId);
        this.fetcher.fetchClass(classModel);
        return classModel;
    };
    AsyncModel.prototype.createLinkType = function (linkTypeId) {
        if (this.graph.getLinkType(linkTypeId)) {
            return _super.prototype.createLinkType.call(this, linkTypeId);
        }
        var linkType = _super.prototype.createLinkType.call(this, linkTypeId);
        var setting = this.linkSettings[linkType.id];
        if (setting) {
            var visible = setting.visible, showLabel = setting.showLabel;
            linkType.setVisibility({ visible: visible, showLabel: showLabel, preventLoading: true });
        }
        this.fetcher.fetchLinkType(linkType);
        return linkType;
    };
    AsyncModel.prototype.createProperty = function (propertyIri) {
        if (this.graph.getProperty(propertyIri)) {
            return _super.prototype.createProperty.call(this, propertyIri);
        }
        var property = _super.prototype.createProperty.call(this, propertyIri);
        this.fetcher.fetchPropertyType(property);
        return property;
    };
    AsyncModel.prototype.onLinkInfoLoaded = function (links) {
        var allowToCreate;
        var cancel = function () { allowToCreate = false; };
        for (var _i = 0, links_1 = links; _i < links_1.length; _i++) {
            var linkModel = links_1[_i];
            this.createLinkType(linkModel.linkTypeId);
            allowToCreate = true;
            this.source.trigger('createLoadedLink', { source: this, model: linkModel, cancel: cancel });
            if (allowToCreate) {
                this.createLinks(linkModel);
            }
        }
    };
    AsyncModel.prototype.createLinks = function (data) {
        var sources = this.graph.getElements().filter(function (el) { return el.iri === data.sourceId; });
        var targets = this.graph.getElements().filter(function (el) { return el.iri === data.targetId; });
        var typeId = data.linkTypeId;
        for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
            var source = sources_1[_i];
            for (var _a = 0, targets_1 = targets; _a < targets_1.length; _a++) {
                var target = targets_1[_a];
                this.addLink(new elements_1.Link({ typeId: typeId, sourceId: source.id, targetId: target.id, data: data }));
            }
        }
    };
    AsyncModel.prototype.loadEmbeddedElements = function (elementIri) {
        var _this = this;
        var elements = this.groupByProperties.map(function (groupBy) {
            return _this.dataProvider.linkElements({
                elementId: elementIri,
                linkId: groupBy.linkType,
                offset: 0,
                direction: groupBy.linkDirection,
            });
        });
        return Promise.all(elements).then(function (res) {
            return res.reduce(function (memo, current) { return Object.assign(memo, current); }, {});
        });
    };
    return AsyncModel;
}(model_1.DiagramModel));
exports.AsyncModel = AsyncModel;
function restoreLinksBetweenElements(model, elementIris) {
    return history_1.Command.effect('Restore links between elements', function () {
        model.requestElementData(elementIris);
        model.requestLinksOfType();
    });
}
exports.restoreLinksBetweenElements = restoreLinksBetweenElements;
